import { useState, useCallback } from 'react';
import gamesService, { Game } from '../services/gamesService';
import type { ScannerConfig } from '../types/features/games';

export const useGames = () => {
  const [games, setGames] = useState<Game[]>([]);
  const [selectedGame, setSelectedGame] = useState<string>('');
  const [scannerConfig, setScannerConfig] = useState<ScannerConfig | null>(null);
  const [loading, setLoading] = useState(false);

  const loadGames = useCallback(async (stateCode?: string) => {
    try {
      setLoading(true);
      // Prefer filtered API when state is provided
      let gamesData: Game[] = [];
      if (stateCode && stateCode.trim().length > 0) {
        const resp = await gamesService.getGames(stateCode.trim());
        gamesData = (resp.success && Array.isArray(resp.data)) ? (resp.data as Game[]) : [];
        setScannerConfig(resp.scanner_config ?? null);
      } else {
        gamesData = await gamesService.getAllGames();
        setScannerConfig(null);
      }
      setGames(gamesData);
      if (gamesData.length > 0) {
        setSelectedGame(gamesData[0].id);
      } else {
        setSelectedGame('');
      }
    } catch (err) {
      console.error('Error loading games:', err);
      throw new Error('Failed to load games data');
    } finally {
      setLoading(false);
    }
  }, []);

  const handleGameChange = useCallback((event: any) => {
    setSelectedGame(event.target.value);
  }, []);

  const getSelectedGameData = useCallback(() => {
    return games.find(game => game.id === selectedGame);
  }, [games, selectedGame]);

  return {
    games,
    selectedGame,
    scannerConfig,
    loading,
    loadGames,
    handleGameChange,
    getSelectedGameData,
  };
}; 
